module.exports = __webpack_public_path__ + "static/media/si_5.106823b4.JPG";